import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    id: null,
    loading: false,
    currentConversationId: null,
    instructionBufferStack: [],
    renderStack: [],
    isTypingMessage: null,
};
export var publicBot = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
